import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    color: '#7df3e1',
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: '0.04em',
    whiteSpace: 'nowrap',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return <div className={classes.logo}>Intern IT</div>;
};

